exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".review-form[data-v-379220dc]{color:#fff}.grade-card .content[data-v-379220dc]{display:flex;flex-direction:column;border-radius:.5rem;border-width:2px;text-align:center;padding:.5rem .75rem;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}.grade-card--big[data-v-379220dc]{width:20%;padding-left:.75rem}.grade-card--big .content .title[data-v-379220dc]{font-size:60px;line-height:70px}.grade-card--big .content .subtitle[data-v-379220dc]{font-size:18px}.grade-card--small[data-v-379220dc]{padding-left:.75rem;width:10%;font-size:25px}", ""]);

// exports
